import { Box, Button, IconButton } from "@material-ui/core"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"
import { useFormikContext } from "formik"
import PropTypes from "prop-types"
import { v4 as uuidv4 } from "uuid"

import Position from "./Position"
import useStyles from "./styles"

const Step3 = ({ setPositionsArray, positionsArray }) => {
  const classes = useStyles()
  const { values } = useFormikContext()

  const addPosition = () => {
    setPositionsArray((oldState) => [...oldState, { id: uuidv4() }])
  }

  const deletePosition = (id) => {
    if (positionsArray?.length > 1) {
      setPositionsArray((oldState) => oldState.filter((x) => x.id !== id))
    }
  }
  return (
    <Box>
      <Box position="absolute" top={15} right={20}>
        <Button onClick={addPosition}>Add Position</Button>
      </Box>
      {positionsArray.map((x) => (
        <Box key={x.id} position="relative">
          {positionsArray?.length > 1 && (
            <IconButton
              className={classes.deletePosition}
              onClick={() => deletePosition(x.id)}
            >
              <HighlightOffIcon />
            </IconButton>
          )}
          <Position
            boardTerm={values?.term}
            position={x}
            setPositionsArray={setPositionsArray}
            positionsArray={positionsArray}
            positions={values.positions}
          />
        </Box>
      ))}
    </Box>
  )
}

Step3.propTypes = {
  clicked: PropTypes.bool,
  positionsArray: PropTypes.array,
  setPositionsArray: PropTypes.func,
}

export default Step3
